import type { FeedbackOpenContext } from "./types"

type Listener = (ctx: FeedbackOpenContext) => void

const listeners = new Set<Listener>()

export const feedbackEventBus = {
  emit(event: "open", ctx: FeedbackOpenContext): void {
    if (event !== "open") return
    listeners.forEach(l => {
      try {
        l(ctx)
      } catch {
        /* swallow listener errors */
      }
    })
  },
  subscribe(listener: Listener): () => void {
    listeners.add(listener)
    return () => {
      listeners.delete(listener)
    }
  },
}
